import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { ToastyService } from "ng2-toasty";
import { OscService } from "../../core/services/proponente/osc.service";
import { ErrorHandlerService } from "./../../core/error-handler.service";
import { NotificacaoHasUsuario, Usuario } from "./../../core/model";
import { CelebracaoService } from "./../../core/services/celebracao/celebracao.service";
import { ConcedenteService } from "./../../core/services/concedente/concedente.service";
import {
  NotificacaoHasUsuarioFiltro,
  NotificacaoHasUsuarioService,
} from "./../../core/services/notificacao/notificacaoHasUsuario.service";
import { TrocaEntidadeService } from "../../core/services/troca-entidade.service";
import { AuthService } from "./../../seguranca/auth.service";
import { UsuarioService } from "./../../usuario/usuario.service";
import { nextRender, safeUpdate } from "../../core/utils/change-detection-safe";

declare let AdminLTE: any;

@Component({
  standalone: false,
  selector: "app-home",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.css"],
})
export class HomePageComponent implements OnInit, AfterViewInit {
  filtroNotificacaoHasUsuario = new NotificacaoHasUsuarioFiltro();
  notificacaoHasUsuario = new NotificacaoHasUsuario();
  listaNotificacao = [];
  carregandoNotificacoes = true;
  openModalAviso = false;
  senha: string;
  modalSenhaFraca = false;
  novaSenha: string;
  confirmarSenha: string;
  senhaValida: boolean = false;
  usuario: Usuario = new Usuario();
  hoveredIcon: string = '';
  homeCarregada = false;
  carregandoHome = true;
  exibirCarregamentoHome = true;
  exibirConteudoHome = false;

  constructor(
    public auth: AuthService,
    private title: Title,
    private notificacaoHasUsuarioService: NotificacaoHasUsuarioService,
    private usuarioService: UsuarioService,
    private proponentesService: OscService,
    private celebracaoService: CelebracaoService,
    private concedenteService: ConcedenteService,
    private router: Router,
    private toasty: ToastyService,
    private errorHandler: ErrorHandlerService,
    private trocaEntidadeService: TrocaEntidadeService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    AdminLTE.init();
    this.title.setTitle("Home");

    this.novaSenha = "";
    this.confirmarSenha = "";
  }

  ngAfterViewInit(): void {
    nextRender(() => this.carregarDadosIniciais());
  }

  private carregarDadosIniciais() {
    this.homeCarregada = false;
    this.carregandoHome = true;
    this.exibirCarregamentoHome = true;
    this.exibirConteudoHome = false;

    Promise.all([
      this.usuarioService.countUsuario().catch(() => 0),
      this.proponentesService.countEntidade().catch(() => 0),
      this.concedenteService.countEntidade().catch(() => 0),
      this.celebracaoService.countProjetos().catch(() => 0),
    ]).then(([usuarios, proponentes, concedentes, projetos]) => {
      safeUpdate(() => {
        this.countUsuarios = usuarios || 0;
        this.countProponentes = proponentes || 0;
        this.countConcedentes = concedentes || 0;
        this.countProjetos = projetos || 0;
        this.carregandoHome = false;
        this.homeCarregada = true;
        this.exibirCarregamentoHome = false;
        this.exibirConteudoHome = true;
        this.cdRef.detectChanges();
      });
    });

    this.listarNotificacoesHasUser();
    if (sessionStorage.getItem("urlLogin")) {
      sessionStorage.removeItem("urlLogin");
      this.senha = sessionStorage.getItem("password");
      //  this.openModalAviso = true;
      this.alertaSenhaFraca();
    
    }
  }

  alertaSenhaFraca() {
    this.trocaEntidadeService.solicitarAbertura();
    sessionStorage.removeItem("password");
    if (this.senha.length <= 3) {
      this.modalSenhaFraca = true;
    this.usuarioService.buscarPorCodigo(this.auth.jwtPayload.id)
      .then((usuario: Usuario) => {
        this.usuario = usuario;
      })
      .catch((erro) => this.errorHandler.handle(erro));
    }

  }

  alterarSenha() {
    if (this.novaSenha === this.confirmarSenha && this.novaSenha.length >= 8) {
      if (this.usuario.entidadeProponente) {
        delete this.usuario.entidadeProponente.habilitacao;
      }     
      this.usuario.senha = this.novaSenha;
      this.usuario.senha_antiga = this.senha;
    
      this.usuarioService
        .atualizar(this.usuario)
        .then(() => {
          this.toasty.success(
            "Senha alterada com sucesso! Acesse o sistema novamente para que as alterações tenham efeito."
          );
          this.modalSenhaFraca = false;
          this.novaSenha = "";
          this.confirmarSenha = "";
        })
        .catch((erro) => this.errorHandler.handle(erro));
    } else {
      this.toasty.error(
        "As senhas não coincidem ou não atendem aos requisitos mínimos"
      );
      return;
    }
  }

  //==================Listagem dos Cards
  countUsuarios = 0;
  countProponentes = 0;
  countConcedentes = 0;
  countProjetos = 0;
  //===========.Fim listagem

  listarNotificacoesHasUser() {
    this.carregandoNotificacoes = true;
    this.filtroNotificacaoHasUsuario.itensPorPagina = 5;
    this.filtroNotificacaoHasUsuario.usuario = this.auth.jwtPayload.id;
    this.notificacaoHasUsuarioService
      .pesquisarResumo(this.filtroNotificacaoHasUsuario)
      .then((lista) => {
        safeUpdate(() => {
          this.listaNotificacao = lista.content;
          this.carregandoNotificacoes = false;
          this.cdRef.detectChanges();
        });
      })
      .catch(() => {
        safeUpdate(() => {
          this.carregandoNotificacoes = false;
          this.cdRef.detectChanges();
        });
      });
  }

  setaNotificacaoSessao(notificacao) {
    // A listagem da home usa uma projecao leve (sem o objeto completo), entao
    // buscamos o registro completo por id antes de marcar como lida/visualizar,
    // mantendo o fluxo de atualizacao (PUT) e a tela de visualizacao intactos.
    this.notificacaoHasUsuarioService
      .buscarPorCodigo(notificacao.id)
      .then((completo: any) => {
        if (completo.statusNotificacao === "Lida") {
          sessionStorage.setItem("verNotificacao", JSON.stringify(completo));
          this.router.navigate(["/notificacao/visualizar"]);
        } else {
          completo.statusNotificacao = "Lida";
          this.notificacaoHasUsuarioService
            .atualizar(completo)
            .then((resultado) => {
              this.toasty.info("Notificacao atualizada para visualizada.");
              sessionStorage.setItem("verNotificacao", JSON.stringify(resultado));
              this.router.navigate(["/notificacao/visualizar"]);
            })
            .catch((erro) => this.errorHandler.handle(erro));
        }
      })
      .catch((erro) => this.errorHandler.handle(erro));
  }
}
